import { useEffect } from 'react';
import Router from 'config/routes';
import { useAuth } from 'entities/Auth';
import { LocalStorageKeyEnum, LanguageEnum } from 'utils/constants';
import './App.css';
import { isNil } from 'lodash';

const App = () => {
  const { userInfo, updateUserLanguage, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && !isNil(userInfo?.language_preference)) {
      updateUserLanguage(userInfo.language_preference);
    } else {
      const storedLang =
        (localStorage.getItem(LocalStorageKeyEnum.LANGUAGE_PREFERENCE) as LanguageEnum) || LanguageEnum.EN;
      updateUserLanguage(storedLang);
    }
  }, [userInfo?.language_preference, isAuthenticated, updateUserLanguage]);

  return <Router />;
};

export default App;
